import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import OlocConfirmationScreen from '~/components/members-area/oloc/OlocConfirmationScreen.vue';
import DisclosureModal from '~/components/members-area/DisclosureModal.vue';
import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
import { generateMetaHead } from '~/utils/head';
export default {
  name: 'OLOC',
  components: {
    OlocConfirmationScreen,
    DisclosureModal,
    LoadingOverlay
  },
  layout: 'empty',
  data() {
    return {
      loading: true,
      disclosureFile: '',
      showDisclosure: false,
      showSuccess: false,
      showSuccessFadeIn: false,
      showError: false,
      fromApp: false,
      policy: {},
      memberProfile: {},
      metadata: {},
      // TODO: this might warrant an api endpoint update to include this data

      baseUrl: this.$config.apiBaseUrl,
      token: ''
    };
  },
  head() {
    return generateMetaHead({
      title: 'Lead Line of Credit Agreement | Extra',
      description: "We've updated our agreements, please take a look and agree to continue.",
      htmlAttrs: {
        class: 'theme-light'
      }
    });
  },
  computed: {
    source() {
      return this.token ? 'oloc-link' : 'oloc-app';
    }
  },
  async mounted() {
    var _window;
    const {
      token,
      from_app
    } = this.$route.query;
    this.token = token || window.sessionStorage.getItem('EXTRA_OLOC_TOKEN');

    // Remove token from query parameter, if supplied
    this.$router.replace({
      query: {
        token: undefined
      }
    });

    // Save OLOC token in session storage, if present
    if (this.token) {
      window.sessionStorage.setItem('EXTRA_OLOC_TOKEN', this.token);
    }
    this.fromApp = !!((_window = window) !== null && _window !== void 0 && _window.sessionStorage.getItem('EXTRA_FROM_APP') || from_app);
    const data = await this.fetchPolicies(this.token);
    this.$analyticsHub.identify(this.memberProfile.id, {
      user_id: this.memberProfile.extra_user_id
    });
    if (this.token) {
      this.$analyticsHub.track('[Single Page OLOC][Web] OLOC token authenticated link visit');
    }

    // Check if user has already completed agreements
    if (!data.show || data.__debug.signed) {
      this.$analyticsHub.track('[Single Page OLOC][Web] User already completed agreements OR is ineligible', {
        source: this.source
      });
      this.postAgreementRedirect();
    }
  },
  methods: {
    async fetchPolicies(token) {
      try {
        var _this$policy$policyMe;
        // throw error if token is not present
        if (!token) {
          throw new Error('Token not present');
        }
        const requestConfig = {
          method: 'GET',
          url: `${this.baseUrl}/users/me/agreements/lead-loc`,
          headers: {
            authorization: `Bearer OLOC:${token}`
          }
        };
        const {
          data
        } = await this.$axios.request(requestConfig);
        this.policy = data.policy;
        this.memberProfile = data.memberProfile;
        dayjs.extend(AdvancedFormat); // required for the 'Do' format
        this.metadata = {
          ...this.policy.policyMetadata,
          current_date: dayjs().format('MMMM D, YYYY'),
          process_day: dayjs(this.policy.policyMetadata.process_day).format('Do'),
          process_month: this.policy.policyMetadata.billing_cycle === 'annual' ? `${dayjs(this.policy.policyMetadata.process_day).format('MMMM')} each year` : 'each month',
          formatted_plan_cost: (_this$policy$policyMe = this.policy.policyMetadata.plan_cost) === null || _this$policy$policyMe === void 0 ? void 0 : _this$policy$policyMe.toFixed(2),
          formatted_process_date: dayjs(this.policy.policyMetadata.process_day).format('MMMM Do, YYYY'),
          source: this.source
        };
        this.loading = false;
        return data;
      } catch (err) {
        this.$sentry.captureException(err);
        this.showError = true;
        if (this.fromApp) {
          this.loading = false;
        } else {
          this.postAgreementRedirect();
        }
      }
    },
    async submitAgreements(token) {
      try {
        this.policy.metadata = this.metadata;
        const requestConfig = token ? {
          method: 'POST',
          url: `${this.baseUrl}/users/me/agreement/save`,
          headers: {
            authorization: `Bearer OLOC:${token}`
          },
          data: {
            agreements: [this.policy],
            trigger: 'website-magic-link'
          }
        } : {
          method: 'POST',
          url: '/app-not-currently-hooked-up'
        };
        console.log('requestConfiggg', requestConfig);
        await this.$axios.request(requestConfig);
      } catch (err) {
        this.$sentry.captureException(err);
        this.showError = true;
      } finally {
        this.loading = false;
      }
    },
    viewedDisclosure() {
      this.showDisclosure = false;
    },
    showThisDisclosure(disc) {
      this.disclosureFile = disc;
      this.showDisclosure = true;
    },
    postAgreementRedirect() {
      if (this.fromApp) {
        this.$router.push('/app/dismiss');
      } else {
        this.$router.push('/download');
      }
    },
    async confirmPlan() {
      this.loading = true;
      await this.submitAgreements(this.token);
      this.showSuccess = true;
      this.$confetti.start();
      this.$analyticsHub.track('Single Page OLOC Submitted', {
        source: this.metadata.source
      });
      window.setTimeout(() => this.showSuccessFadeIn = true, 200);
      window.setTimeout(() => {
        this.$confetti.stop();
      }, 3000);
      window.setTimeout(() => {
        this.postAgreementRedirect();
      }, 5000);
    }
  }
};